import { Component, Output, EventEmitter, computed, input } from '@angular/core';
import { AnalyticsCellValue } from '../analytics.model';

@Component({
    selector: 'key-analytics-pivot-table',
    templateUrl: './pivot-table.component.html',
    styleUrls: ['./pivot-table.component.scss'],
    standalone: false
})
export class AnalyticsPivotTableComponent {
    cellset = input<AnalyticsCellValue[][]>();
    selected = input<string>();
    @Output() onHeaderClick = new EventEmitter<AnalyticsCellValue>();

    updatedCellset = computed(() => {
        return this.cellset().map(row => row.map(cell => ({ ...cell, value: String(cell.value) })) );
    });

    constructor(
    ) { }

    doOnHeaderClick(header: AnalyticsCellValue) {
        if (header.properties.color) {
            this.onHeaderClick.emit(header);
        }
    }

    convertToClassListString(classnames: string[] = []): string {
        return classnames.reduce((all, cur) => all + ' ' + cur, '');
    }
}
